import * as React from "react";
import type { SVGProps } from "react";
const SvgBottomLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="bottom_left_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M343.424 620.373V300.928a42.667 42.667 0 0 0-85.333 0v421.973c0 23.766 19.285 43.094 43.093 43.094h421.973a42.667 42.667 0 1 0 0-85.334H403.712L755.2 329.216c15.616-15.616 14.763-41.813-1.92-58.453-16.64-16.64-42.837-17.494-58.453-1.878l-351.36 351.446z"
    />
  </svg>
);
export default SvgBottomLeftIcon;
